export default {
      id: "icon-check-usage",
      viewBox: "0 0 96 96",
      url: "/" + "assets/sprite.svg#icon-check",
      toString: function () {
        return this.url;
      }
    }